module.exports = __webpack_public_path__ + "static/ScreenShot-856df5aaca5ea35631212decb190f2f5.jpg";